import updateUser from './editUserService';

const respondWith = ({ ok = true, status = 200, body = {} }) => {
  global.fetch = jest
    .fn()
    .mockResolvedValue({ ok, status, json: async () => body });
};

beforeEach(() => {
  document.head.innerHTML = '<meta name="csrf-token" content="a-token" />';
});

afterEach(() => {
  document.head.innerHTML = '';
  // jest.restoreAllMocks cannot undo a plain global assignment — see the note in
  // EditUserContent.test.jsx.
  delete global.fetch;
});

describe('management/EditUser editUserService', () => {
  it('patches the user path', async () => {
    respondWith({ body: { user: { id: 7 } } });

    await updateUser(7, { first_name: 'Abe' });

    expect(global.fetch).toHaveBeenCalledWith(
      '/management/users/7',
      expect.objectContaining({
        method: 'PATCH',
        body: JSON.stringify({ user: { first_name: 'Abe' } }),
      }),
    );
  });

  // Rails rejects a PATCH without it, so the page would appear to save nothing.
  it('sends the CSRF token from the page', async () => {
    respondWith({ body: { user: { id: 7 } } });

    await updateUser(7, {});

    const { headers } = global.fetch.mock.calls[0][1];
    expect(headers['X-CSRF-Token']).toBe('a-token');
  });

  it('returns the re-read user on success', async () => {
    respondWith({ body: { user: { id: 7, firstName: 'Abe' } } });

    await expect(updateUser(7, {})).resolves.toEqual({
      user: { id: 7, firstName: 'Abe' },
    });
  });

  // A rejected record is an ordinary outcome of a form, so it comes back as a value
  // for the fields to render rather than as an exception.
  it('returns the field errors on 422 rather than throwing', async () => {
    respondWith({
      ok: false,
      status: 422,
      body: { errors: { email: ['has already been taken'] } },
    });

    await expect(updateUser(7, {})).resolves.toEqual({
      errors: { email: ['has already been taken'] },
    });
  });

  // What a viewer without user-management:Modify gets by posting around the disabled
  // form. The controller sends a reason, so it is worth showing rather than throwing.
  it('returns the reason a 403 carries', async () => {
    respondWith({
      ok: false,
      status: 403,
      body: { errors: { base: ['You do not have permission to edit users.'] } },
    });

    await expect(updateUser(7, {})).resolves.toEqual({
      errors: { base: ['You do not have permission to edit users.'] },
    });
  });

  // Nothing to attach to a field and nothing to say: an HTML error page, a proxy
  // timeout, a 500.
  it('throws on a failure carrying no messages', async () => {
    respondWith({ ok: false, status: 500, body: {} });

    await expect(updateUser(7, {})).rejects.toThrow('status: 500');
  });

  it('throws on a failure whose body is not JSON', async () => {
    global.fetch = jest.fn().mockResolvedValue({
      ok: false,
      status: 502,
      json: async () => {
        throw new Error('Unexpected token < in JSON');
      },
    });

    await expect(updateUser(7, {})).rejects.toThrow('status: 502');
  });
});
